import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    stage: 1,
    myInfo: false,
    clientId: null,
    createCustomerFlow: false,
};

const stageSuccess = (state, action) => {
    return updateObject(state, {
        stage: action.stage,
    });
};

const sourceUpdateSuccess = (state, action) => {
    return updateObject(state, {
        myInfo: action.flag,
    });
};

const updateFlowFlags = (state, action) => {
    return updateObject(state, {
        ...action.data,
    });
};

const mainReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STAGE_SUCCESS:
            return stageSuccess(state, action);

        case actionTypes.UPDATE_SOURCE_SUCCESS:
            return sourceUpdateSuccess(state, action);

        case actionTypes.UPDATE_FLOW_FLAGS:
            return updateFlowFlags(state, action);

        case actionTypes.UPDATE_CUSTOMER_FLOW:
            return {
                ...state,
                createCustomerFlow: action.createCustomerFlow,
            };

        case actionTypes.LOAD_CLIENT_ID:
            return {
                ...state,
                clientId: action.clientId,
            };

        default:
            return state;
    }
};

export default mainReducer;
